<template>
  <div class="page">
    <a-card title="添加广告" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model class="form-class" ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-row>
          <a-col :span="8">
            <span class="card-title">1.选择广告场景</span>
          </a-col>
        </a-row>
        <a-form-model-item prop="adScene" label="广告场景">
          <a-radio-group name="radioGroup" v-model="ruleForm.adScene" @change="changeAdScene">
            <a-radio :value="1">
              <a-tooltip>
                <template slot="title">以弹窗形式展示广告</template>
                <span>弹窗广告</span>
              </a-tooltip>
            </a-radio>
            <a-radio :value="5">
              <a-tooltip>
                <template slot="title">首页搜索页滚动显示</template>
                <span>首页搜索广告</span>
              </a-tooltip>
            </a-radio>
            <a-radio :value="6">
              <a-tooltip>
                <template slot="title">搜索页搜索发现展示广告</template>
                <span>搜索发现广告</span>
              </a-tooltip>
            </a-radio>
            <a-radio :value="7">
              <a-tooltip>
                <template slot="title">微信小程序启动展示广告</template>
                <span>开屏广告</span>
              </a-tooltip>
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.adScene==1" label="卡面图片" prop="adImage" style="margin-bottom: 0;">
          <div>温馨提示：图片建议上传尺寸最低为600px*360px、最高600px*840px，格式.jpg、.png、.jpeg、gif</div>
          <div class="upload-box-card">
            <a-upload
              name="avatar"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="actionImageUrl"
              @change="handleChange"
              :before-upload="beforeUploadFile"
            >
              <img v-if="ruleForm.adImage" :src="ruleForm.adImage" alt="avatar" class="img-avatar"/>
              <div v-else>
                <a-icon type="plus"/>
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-row>
          <a-col :span="8">
            <span class="card-title">2.选择广告位置及类型</span>
          </a-col>
        </a-row>
        <div v-if="ruleForm.adScene==1">
          <a-form-model-item prop="adPosition" label="广告位置">
            <a-checkbox-group name="radioGroup" v-model="ruleForm.adPosition">
              <a-checkbox value="1">首页</a-checkbox>
              <a-checkbox value="2">商品详情页</a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item prop="type" label="内容类型">
            <a-radio-group name="radioGroup" v-model="ruleForm.type" @change="onChangeType">
              <a-radio :value="1">商品</a-radio>
              <a-radio :value="2">链接</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="ruleForm.type==1" label="关联商品" prop="content">
            <a-button @click="showSelectedDialog = true">选择</a-button>
            <span class="pl15" v-if="ruleForm.content">&nbsp;商品ID：{{ ruleForm.content }}</span>
          </a-form-model-item>
          <a-form-model-item v-else label="链接" prop="content">
            <a-input v-model="ruleForm.content" :maxLength="510" placeholder="小程序仅支持安全域名下的链接"/>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.adScene==5">
          <a-form-model-item
            v-for="(item, index) in ruleForm.adContentEntityDtoList"
            :key="index"
            :label-col="index === 0 ? currentFormLayout.labelCol : {}"
            :wrapper-col="index === 0 ?currentFormLayout.wrapperCol:currentFormLayout.offsetCol"
            :label="index === 0 ? '广告文字' : ''"
            :prop="'adContentEntityDtoList.' + index + '.content'"
            :rules="{ required: true, message: '请输入广告文字', trigger: 'blur',}"
          >
            <a-input v-model="item.content" :maxLength="10" placeholder="请输入" style="margin-right: 8px"/>
            <a-icon
              v-if="ruleForm.adContentEntityDtoList.length > 1"
              class="dynamic-delete-button"
              type="minus-circle-o"
              :disabled="ruleForm.adContentEntityDtoList.length === 1"
              @click="removeDomain(item)"
            />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
            <a-button type="dashed" style="width: 400px" @click="addDomain">
              <a-icon type="plus"/>
              新增广告
            </a-button>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.adScene==6">
          <a-form-model-item prop="type" label="内容类型">
            <a-radio-group name="radioGroup" v-model="ruleForm.type" @change="onChangeType">
              <a-radio :value="1">商品</a-radio>
              <a-radio :value="2">链接</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div v-for="(item, index) in ruleForm.adContentEntityDtoList" :key="index">
            <a-form-model-item
              :label="'广告标题'+(index+1)"
              :prop="'adContentEntityDtoList.' + index + '.title'"
              :rules="{ required: true, message: '请输入广告标题', trigger: 'blur',}"
            >
              <a-input v-model="item.title" :maxLength="10" placeholder="请输入" style="margin-right: 8px"/>
              <a-icon
                v-if="ruleForm.adContentEntityDtoList.length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :disabled="ruleForm.adContentEntityDtoList.length === 1"
                @click="removeTitle(item)"
              />
            </a-form-model-item>
            <div v-if="ruleForm.type==1">
              <a-form-model-item
                :label="'关联商品'+(index+1)"
                :prop="'adContentEntityDtoList.' + index + '.content'"
                :rules="{required: true,message: '请选择',trigger: 'blur',}"
              >
                <a-button type="primary" @click="showModal(index)">选择</a-button>
                <span style="margin-left: 20px" v-if="item.content">商品ID：{{ item.content }}</span>
              </a-form-model-item>
            </div>
            <div v-if="ruleForm.type==2">
              <a-form-model-item
                :label="'广告链接'+(index+1)"
                :prop="'adContentEntityDtoList.' + index + '.content'"
                :rules="{ required: true, message: '请输入广告链接', trigger: 'blur',}"
              >
                <a-input v-model="item.content" placeholder="小程序仅支持安全域名下的链接" style="margin-right: 8px"/>
              </a-form-model-item>
            </div>
          </div>
          <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
            <a-button type="dashed" style="width: 400px" @click="addTitle">
              <a-icon type="plus"/>
              添加
            </a-button>
          </a-form-model-item>
        </div>
        <div v-if="ruleForm.adScene==7">
          <a-form-model-item label="广告图片">
            温馨提示：建议上传尺寸为750px*1624px，格式jpg、png、jpeg，大小2M以内
            <a-upload
              :multiple="true"
              :action="uploadFileUrl"
              list-type="picture-card"
              :file-list="fileList"
              :beforeUpload="beforeUpload"
              @change="handleAdPictureChange"
            >
              <div v-if="fileList.length < 9">
                <a-icon type="plus"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </div>
        <a-row>
          <a-col :span="8">
            <span class="card-title">3.输入广告位名称及投放时间</span>
          </a-col>
        </a-row>
        <a-form-model-item prop="adName" label="广告名称">
          <a-input v-model="ruleForm.adName" placeholder="请输入" :maxLength="20"/>
        </a-form-model-item>
        <a-form-model-item prop="validGetDate" label="投放时间">
          <a-range-picker name="buildTime" :disabledDate="disabledDate"
                          v-model="ruleForm.validGetDate"
                          @change="onDateChange"
                          format="YYYY-MM-DD"/>
        </a-form-model-item>
        <a-row>
          <a-col :span="8">
            <span class="card-title">4.投放人群及投放规则</span>
          </a-col>
        </a-row>
        <a-form-model-item prop="showUserType" label="投放人群">
          <a-radio-group name="radioGroup" v-model="ruleForm.showUserType">
            <a-radio :value="1">用户</a-radio>
            <a-radio :value="2">分销员</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <!-- <a-form-model-item label="用户标签">
          <a-table :columns="personColumns" rowKey="key"
            :dataSource="personnelList" :pagination="false">
          </a-table>
        </a-form-model-item>
        <a-form-model-item label="分销员标签">
          <a-table :columns="personColumns" rowKey="key"
                   :dataSource="personnelList" :pagination="false">
          </a-table>
        </a-form-model-item> -->
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button v-if="status==0" type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
          <a-button @click="goBack">返回</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="img-list">
        <img v-if="ruleForm.adScene==1" src="https://imgb.woyoubooking.com/sketch_bg_image/home_dialog_bg.png">
        <img v-if="ruleForm.adScene==5" src="https://imgb.woyoubooking.com/sketch_bg_image/search_bg.png">
        <img v-if="ruleForm.adScene==6" src="https://imgb.woyoubooking.com/sketch_bg_image/search-find-img.png">
      </div>
      <selected-product-dialog
        :show="showSelectedDialog"
        ref="pageList"
        :itemNames="['search_proId','search_proName']"
        :query-params="selectedQueryParams"
        :requestPromise="loadPromise"
        row-key="proId"
        @close="showSelectedDialog=false"
        :columns="getGoodsColumns()"
      >
        <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
          <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
        </a-form-item>
        <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
          <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
        </a-form-item>
        <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
        <template slot="action" slot-scope="rowItem">
          <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
        </template>
      </selected-product-dialog>
    </a-card>
  </div>
</template>

<script>
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import moment from 'moment'

export default {
  name: 'NewAdvertisiing',
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      adId: this.$route.query.adId,
      status: this.$route.query.status,
      showSelectedDialog: false,
      actionImageUrl: this.getAppConfig().baseUrl + 'base/upload',
      submitLoading: false,
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      selectedQueryParams: {
        proStatus: 1
      },
      loadPromise: params => this.getListPromise(params),
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 3 },
          md: { span: 5 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 21 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 21 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 3 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 5 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        adScene: 1,
        id: null,
        adPosition: [],
        adImage: '',
        type: 1,
        showUserType: '',
        adContentEntityDtoList: [
          { content: '' }
        ],
        content: '',
        validStartTime: '',
        validEndTime: '',
        validGetDate: undefined,
        proCatalogId: ''
      },
      disabledDate(current) {
        return current && current < moment().startOf('day')
      },
      rules: {
        adScene: [
          { required: true, message: '请选择广告场景', trigger: 'change' }
        ],
        adImage: [
          { required: true, message: '上传广告图片', trigger: ['blur', 'change'] }
        ],
        adPosition: [
          { required: true, message: '请选择广告位置', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择内容类型', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请完善信息', trigger: ['blur', 'change'] }
        ],
        adName: [
          { required: true, message: '请输入广告名称', trigger: 'blur' }
        ],
        validGetDate: [
          { required: true, message: '请选择投放时间', trigger: 'change' }
        ],
        showUserType: [
          { required: true, message: '请选择投放人群', trigger: 'change' }
        ]
      },
      daysList: [],
      personnelList: [],
      personColumns: [
        {
          title: 'ID',
          key: 'ID',
          dataIndex: 'ID'
        },
        {
          title: '标签名称',
          key: 'tipsName',
          dataIndex: 'tipsName'
        },
        {
          title: '用户数',
          key: 'usersName',
          dataIndex: 'usersName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      proIndex: '',
      uploadFileUrl: this.getUploadFileUrl(),
      fileList: [],//选中的文件
      maxCount: 9
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'AdvertisingList', title: '广告列表' }
    ])
    this.getAdvertisingData()
  },
  methods: {
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    handleAdPictureChange({ fileList }) {
      this.getLogUtils().logWithTag('handleChange', fileList)
      // let tempList=[...fileList];
      // const size = fileList.length;
      // if(this.maxCount===1 &&size>1){
      //   tempList=[fileList[size-1]]
      // }
      this.fileList = fileList.map(item => {
        if (item.response) {
          item.url = item.response.data
        }
        return item
      })
      this.getLogUtils().logWithTag('操作handleChange', fileList)
    },
    beforeUpload(file) {
      this.getLogUtils().logWithTag('beforeUpload', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
        return false
      }
      return true
    },
    showModal(index) {
      this.proIndex = index
      this.showSelectedDialog = true
    },
    goBack() {
      this.$router.back(-1)
    },
    changeAdScene(e) {
      let value = e.target.value
      this.ruleForm.adContentEntityDtoList = [
        { content: '' }
      ]
      this.fileList = []
      this.proIndex = ''
      if (value == 1) {
        this.ruleForm.type = 1
        this.ruleForm.adPosition = []
      }
      if (value == 6) {
        this.ruleForm.adContentEntityDtoList[0].adPosition = 4
        this.ruleForm.adContentEntityDtoList[0].type = this.ruleForm.type
        this.getLogUtils().errorWithTag('adContentEntityDtoList', this.ruleForm.adContentEntityDtoList)
      }
    },
    onChangeType(e) {
      this.ruleForm.content = ''
      if (this.ruleForm.adScene == 6) {
        this.ruleForm.adContentEntityDtoList.forEach(item => {
          item.content = ''
          item.type = this.ruleForm.type
        })
      }
    },
    removeDomain(item) {
      let index = this.ruleForm.adContentEntityDtoList.indexOf(item)
      if (index !== -1) {
        this.ruleForm.adContentEntityDtoList.splice(index, 1)
      }
    },
    addDomain() {
      if (this.ruleForm.adContentEntityDtoList.length < 5) {
        this.ruleForm.adContentEntityDtoList.push({
          content: ''
        })
      } else {
        this.$message.error('最多新增5条数据')
      }
    },
    removeTitle(item) {
      let index = this.ruleForm.adContentEntityDtoList.indexOf(item)
      if (index !== -1) {
        this.ruleForm.adContentEntityDtoList.splice(index, 1)
      }
    },
    addTitle() {
      if (this.ruleForm.adContentEntityDtoList.length < 10) {
        this.ruleForm.adContentEntityDtoList.push({
          adPosition: 4,
          type: this.ruleForm.type,
          content: '',
          title: ''
        })
      } else {
        this.$message.error('最多新增10条数据')
      }
    },
    //领取日期
    onDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateChange', dates)
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.ruleForm.validGetDate = dates
      this.ruleForm.validStartTime = dateStrArr[0]
      this.ruleForm.validEndTime = dateStrArr[1]
      this.ruleForm = {
        ...this.ruleForm
      }
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        return
      }
      if (info.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(info.fileList)
        // Get this url from response in real world.
        this.ruleForm.adImage = url
        this.$refs.ruleForm.validateField('adImage', (Error) => {
        })
      }
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    },
    beforeUploadFile(file) {
      this.getLogUtils().logWithTag('beforeUpload', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isGIF = file.type === 'image/gif'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isGIF || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于1M!')
        return false
      }
      return true
    },
    //表格数据
    getListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    onSelectedResult(data) {
      if (this.proIndex !== '') {
        let result = this.ruleForm.adContentEntityDtoList.some(function(item) {
          if (item.content == data.proId) {
            return true
          }
        })
        if (result) {
          this.$message.error('请勿重复添加同一商品')
          return
        }
        this.ruleForm.adContentEntityDtoList[this.proIndex].content = data.proId
        this.ruleForm.adContentEntityDtoList[this.proIndex].proCatalogId = data.proType
      } else {
        this.ruleForm.content = data.proId
        this.ruleForm.proCatalogId = data.proType
        this.$refs.ruleForm.validateField('content', (Error) => {
        })
      }
      this.showSelectedDialog = false
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.getLogUtils().logWithTag('==handleSubmit==', this.ruleForm)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      if (this.submitFormData.adScene == 1) {
        this.submitFormData.adPosition = this.submitFormData.adPosition.join(',')
      } else {
        this.submitFormData.adPosition = '3'//广告位置默认是3
      }
      if (this.submitFormData.adScene == 7) {
        if (!this.fileList || !this.fileList.length) {
          this.$message.error('请上传广告图片')
          this.submitLoading = false
          return
        }
        this.submitFormData.adPosition = '5'
        this.submitFormData.adContentEntityDtoList = this.fileList
          .filter(file => file.status === 'done')
          .map(file => ({
            content: file.url
          }))
      }
      delete this.submitFormData.validGetDate
      this.getHttpServices().getUserService().post('api/v2/ad/submit', this.submitFormData).then(res => {
        this.$message.success('保存广告成功')
        this.goBack()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => {
          setTimeout(() => {
            this.submitLoading = false
          }, 500)
        })
    },
    // 获取信息
    getAdvertisingData() {
      if (this.adId == 0) {
        return
      }
      this.getHttpServices().getUserService().get('api/v2/ad/detail?adId=' + this.adId).then(res => {
        this.getLogUtils().logWithTag('getAdvertisingData', res)
        this.ruleForm = res
        this.ruleForm.validGetDate = this.getDateHelper().getDateMoments(res.validStartTime, res.validEndTime)
        if (this.ruleForm.adScene == 1) {
          this.ruleForm.adContentEntityDtoList = [
            { content: '' }
          ]
        }
        if (this.ruleForm.adScene == 7) {
          this.fileList = this.ruleForm.adContentEntityDtoList.map((item, index) => {
            return {
              uid: `-${index + 1}`,
              status: 'done',
              url: item.content
            }
          })
        }
        this.ruleForm.adPosition = res.adPosition ? res.adPosition.split(',') : []
        this.getLogUtils().logWithTag('this.ruleForm', this.ruleForm)
        this.ruleForm = { ...this.ruleForm }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.pl5 {
  padding-left: 5px;
}

.pl15 {
  padding-left: 15px;
}

.pr5 {
  padding-right: 5px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.form-class {
  width: 75%;
  float: left;
}

.img-list {
  width: 25%;
  float: right;

  img {
    width: 100%;
    height: auto;
  }
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.img-avatar {
  width: 126px;
  height: 126px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
<style>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>